import { AddressSchema } from "@redotech/account-common/address-schema";
import { RateSchema_ } from "@redotech/redo-fulfillment-carrier-common/shipment";
import { WeightSchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { PurchaseLabelType } from "./purchase-label";

export const getLabelRates = {
  name: "getLabelRates" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    fromAddress: AddressSchema,
    toAddress: AddressSchema,
    weight: WeightSchema,
    originalShipmentId: z.string().optional(),
    labelType: createEnum(PurchaseLabelType),
  }),
  output: z.object({
    rates: z.array(RateSchema_),
    originalLabelCost: z.number(),
  }),
};
